<template>
  <div class="bottombox">
    <ul
      class="bottom clearfix"
      v-if="baseData"
    >
      <li class="bottom_list">
        <!-- <i class="icon-unchecked box-checked el-icon-circle-check"></i> -->
        <!-- <span  class="bottom_phone">400&nbsp;988&nbsp;888</span> -->
      </li>
      <li
        class="bottom_list bottom_onshift"
        v-if="baseData.phone !== ''"
      >
        <!-- 24小时全天在线 -->
        <span>平台电话</span>
        <span class="bottom_phone">{{baseData.phone}}</span>
        <span class="bottom_list_line">|</span>
      </li>
      <li class="bottom_list">粤ICP备18079291号-1
        <span class="bottom_list_line">|</span>
      </li>
      <li class="bottom_list">
        珠海市大吉年华信息科技有限公司
        <!-- Zhuhai &nbsp; Qcloud &nbsp;technology&nbsp; CO.LTD -->
      </li>
    </ul>
  </div>
</template>
<script>
import { rap, fetch } from '@/utils/common.js'
let url = {
  base: '/fep/pc/baseInfo/info'
}
url = rap(url)
export default {
  name: 'bottom',
  data() {
    return {
      msg: 'bottom',
      baseData: null
    }
  },
  created() {
    this.fetchBase()
  },
  methods: {
    fetchBase() {
      fetch(url.base).then(res => {
        if (res.status === 200) {
          this.baseData = res.data
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.bottombox {
  // margin-top: 16px;
  width: 100%;
  position: absolute;
  height: 30px;
  line-height: 30px;
  bottom: 0;
  left: 0;
  z-index: 1;
  //padding: 20px 0;
  background: $bg_color;
  border-top: 1px solid $border_color;
  .bottom {
    padding-left: 110px;
  }
  .bottom_list {
    float: left;
    font-size: 12px;
    color: $gray_color;
    .bottom_phone {
      color: $gray_color;
      font-size: 14px;
      font-weight: bold;
      padding-left: 16px;
    }
    .bottom_list_line {
      display: inline-block;
      padding: 0 16px;
    }
  }
  .bottom_onshift {
    padding-left: 16px;
  }
}
</style>
